import { LOCALE } from '@digital-dealer/environments';

import {
  phoneNumberConfigMap,
  ownerTaxConfigMap,
  energyClassConfigMap,
  zipCodesLookupConfig,
  plateNumberConfigMap,
  zipCodeConfigMap,
  modelPricesConfigMap,
} from './configs';

const basicConfig = {
  fields: {
    phoneNumber: phoneNumberConfigMap[LOCALE],
    zip: zipCodeConfigMap[LOCALE],
    plateNumber: plateNumberConfigMap[LOCALE],
  },
  modules: {
    modelChooser: {
      modelsPrices: modelPricesConfigMap[LOCALE],
    },
    modelViewer: {
      energyClass: energyClassConfigMap[LOCALE],
      ownerTax: ownerTaxConfigMap[LOCALE],
      checkout: {
        zipCodesLookup: zipCodesLookupConfig[LOCALE],
      },
    },
  },
};

export default basicConfig;
